import fs from 'node:fs'
import path from 'node:path'
import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import type { BetterstartPresetDefinition } from '@cli-types/preset-engine/presets.js'
import { readPresetTemplate } from '@next-adapter/preset-template-reader/read-preset-template.js'
import { getSchemasDir } from './get-schemas-dir.js'

export function writePresetSchemas(
  cwd: string,
  config: ResolvedBetterstartConfig,
  definition: BetterstartPresetDefinition
): string[] {
  const schemasDir = getSchemasDir(cwd, config)
  const writtenSchemaNames: string[] = []

  for (const schemaFile of definition.schemaFiles) {
    const outputPath = path.join(schemasDir, schemaFile)
    fs.mkdirSync(path.dirname(outputPath), { recursive: true })
    fs.writeFileSync(
      outputPath,
      readPresetTemplate(definition.id, `schemas/${schemaFile}`),
      'utf-8'
    )
    writtenSchemaNames.push(schemaFile.replace(/\.json$/, ''))
  }

  return writtenSchemaNames
}
